var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiIconUtility16Gov({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M6 6h1v8H6zM9 6h1v8H9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9E9E",
    strokeLinejoin: "round",
    d: "M14 6H2V4l6-2 6 2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9E9E",
    strokeLinecap: "round",
    d: "M2 14h12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9E9E",
    strokeLinejoin: "round",
    d: "M3 6h10v8H3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiIconUtility16Gov);
export default __webpack_public_path__ + "static/media/ui-icon-utility-16-gov.7e90be85.svg";
export { ForwardRef as ReactComponent };